import { useRef } from 'react'

import { MultiAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { Form,Formik } from 'formik'
import { interfaces } from 'service/interfaces'

const New = (props) => {
  const { open, handleclose, changeRender } = props
  const createDismissableSnackbar = useCustomSnackbar()

  const formSubmitRef = useRef(null)
  const handleSubmit = () => {
    formSubmitRef.current.click()
  }

  const GRUPO_OBLEAS = [
    {
      id: 'APC',
      tipo: 'APC',
    },
    {
      id: 'C',
      tipo: 'C',
    },
    {
      id: 'NO_APLICA',
      tipo: 'No aplica',
    },
  ]

  const onSubmit = async (values) => {
    const body = {
      ...values,
      grupo_obleas: values.grupo_obleas.map((item) => item.id),
    }
    await interfaces.interfaceTypeVehicle
      .newVehicle(body)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        changeRender()
      })
      .catch((error) =>
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      )
      .finally(handleclose)
  }

  const object = (values, setFieldValue) => [
    {
      class: 'textfield',
      label: 'Nombre',
      name: 'nombre',
      sm: 12,
      xs: 12,
    },
    {
      class: 'textfield',
      label: 'Descripción',
      name: 'descripcion',
      sm: 12,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="grupo_obleas"
          options={GRUPO_OBLEAS}
          getOptionLabel={(e) => e.tipo}
          value={values.grupo_obleas}
          label="Grupo de obleas"
          onChange={(_, value) => {
            setFieldValue('grupo_obleas', value)
          }}
          tagName="tipo"
          heightInput="auto"
        />
      ),
      sm: 12,
      xs: 12,
    },
  ]

  const children = () => {
    return (
      <Formik
        onSubmit={onSubmit}
        initialValues={{
          nombre: '',
          descripcion: '',
          activo: 1,
          grupo_obleas: [],
        }}
      >
        {({ setFieldValue, isSubmitting, values }) => (
          <Form>
            <InputsWithValidate
              fields={object(values, setFieldValue)}
              spacing={2}
              setFieldValue={setFieldValue}
              isSubmitting={isSubmitting}
            />

            <button style={{ display: 'none' }} type="submit" ref={formSubmitRef} />
          </Form>
        )}
      </Formik>
    )
  }

  return (
    <DialogComponent
      open={open}
      handleclose={handleclose}
      title="Nuevo tipo de vehículo"
      children={children()}
      disableChildHeight
      disableBackdropClick
      disableEscapeKeyDown
      actions={<CancelConfirmButtons onClickSubmit={handleSubmit} onClickCancel={handleclose} />}
    />
  )
}

export default New
